import { Box } from '@hivebrite/design-system/Box';
import { ButtonInLink } from '@hivebrite/design-system/ButtonInLink';

import { useLandingContext } from 'hb-react/frontoffice/apps/LiveFeed/contexts/LandingContext';
import IconSurvey from 'hb-react/shared/icons/Survey';

import Landing from '../Landing';
import LandingContent from '../Landing/Content';

const Survey = () => {
  const { id, title, surveyContent } = useLandingContext();

  return (
    <Landing title={__('created a <strong>Survey</strong>')}>
      <Box
        bg="smoke"
        css="border-radius: 2px;"
        display="block"
        mt={4}
        mx={{ _: -4, m: 0 }}
        p={4}
        pb={5}
      >
        <Box alignItems="center">
          <Box color="primary" mr={4}>
            <IconSurvey height={30} width={30} />
          </Box>
          <Box font="h4-semibold">{title}</Box>
        </Box>
        <LandingContent content={surveyContent} mt={4} />
        <Box mt={4}>
          <ButtonInLink
            linkProps={{
              to: Routes.surveys_form_path(id),
            }}
          >
            {I18n.t('web.surveys.answer_survey')}
          </ButtonInLink>
        </Box>
      </Box>
    </Landing>
  );
};

export default Survey;
